import Button from '@mui/material/Button'
import DirectionsCarFilledOutlinedIcon from '@mui/icons-material/DirectionsCarFilledOutlined'
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined'
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined'
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined'
import StarBorderOutlinedIcon from '@mui/icons-material/StarBorderOutlined'
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined'
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import useTheme from '../../hooks/useTheme'

export default function UserQuickActions({
  onShowUserLobbies,
  onShowTransactions,
  onShowBankAccounts,
  onShowRatings,
  onShowChats,
  onShowWallet,
  walletBalances,
  onSendWhatsApp,
  hasBankAccounts,
  isVerified,
  onVerifyUser
}) {
  const { theme } = useTheme()
  const isDark = theme === 'dark'
  const balances = Array.isArray(walletBalances) ? walletBalances.filter(Boolean) : []
  const stackedBalances = balances.length > 1
  const baseStyle = {
    fontSize: '14px',
    backgroundColor: '#e5e7eb',
    color: '#111827',
    textTransform: 'none',
    paddingLeft: '20px',
    paddingRight: '20px',
    paddingTop: '10px',
    paddingBottom: '10px',
    borderRadius: '10px',
    fontFamily: 'Poppins, sans-serif',
    fontWeight: 600,
    boxShadow: 'none',
    gap: '6px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    flex: '1 1 220px'
  }

  return (
    <div className='flex gap-2 mt-2 flex-wrap'>
      <Button
        onClick={onShowUserLobbies}
        variant='contained'
        style={{
          ...baseStyle,
          backgroundColor: isDark ? 'rgba(59,130,246,0.1)' : '#dbeafe',
          color: isDark ? '#60a5fa' : '#1e40af'
        }}
      >
        <DirectionsCarFilledOutlinedIcon fontSize='small' />
        Viajes
      </Button>
      <Button
        onClick={onShowChats}
        variant='contained'
        style={{
          ...baseStyle,
          backgroundColor: isDark ? 'rgba(99,102,241,0.1)' : '#e0e7ff',
          color: isDark ? '#818cf8' : '#3730a3'
        }}
      >
        <ForumOutlinedIcon fontSize='small' />
        Chats
      </Button>
      {onSendWhatsApp && (
        <Button
          onClick={onSendWhatsApp}
          variant='contained'
          style={{
            ...baseStyle,
            backgroundColor: isDark ? 'rgba(34,197,94,0.1)' : '#dcfce7',
            color: isDark ? '#4ade80' : '#15803d'
          }}
        >
          <WhatsAppIcon fontSize='small' />
          Mensaje
        </Button>
      )}
      <Button
        onClick={onShowTransactions}
        variant='contained'
        style={{
          ...baseStyle,
          backgroundColor: isDark ? 'rgba(239,68,68,0.1)' : '#fee2e2',
          color: isDark ? '#f87171' : '#991b1b'
        }}
      >
        <ReceiptLongOutlinedIcon fontSize='small' />
        Transacciones
      </Button>
      {onShowWallet && (
        <Button
          onClick={onShowWallet}
          variant='contained'
          aria-label={balances.length ? `Saldo ${balances.join(' · ')}` : 'Saldo'}
          style={{
            ...baseStyle,
            backgroundColor: isDark ? 'rgba(6,182,212,0.12)' : '#cffafe',
            color: isDark ? '#22d3ee' : '#155e75'
          }}
        >
          <AccountBalanceWalletOutlinedIcon fontSize='small' />
          Saldo
          {balances.length > 0 && (
            <span
              data-testid='wallet-balances'
              style={{
                marginLeft: 'auto',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-end',
                fontVariantNumeric: 'tabular-nums',
                fontWeight: 700,
                fontSize: stackedBalances ? '13px' : undefined,
                lineHeight: stackedBalances ? 1.2 : undefined
              }}
            >
              {balances.map(balance => (
                <span key={balance} style={{ whiteSpace: 'nowrap' }}>
                  {balance}
                </span>
              ))}
            </span>
          )}
        </Button>
      )}
      <Button
        onClick={onShowRatings}
        variant='contained'
        style={{
          ...baseStyle,
          backgroundColor: isDark ? 'rgba(245,158,11,0.1)' : '#fef9c3',
          color: isDark ? '#fbbf24' : '#854d0e'
        }}
      >
        <StarBorderOutlinedIcon fontSize='small' />
        Calificaciones
      </Button>
      {hasBankAccounts && (
        <Button
          onClick={onShowBankAccounts}
          variant='contained'
          style={{
            ...baseStyle,
            backgroundColor: isDark ? 'rgba(16,185,129,0.1)' : '#dcfce7',
            color: isDark ? '#34d399' : '#166534'
          }}
        >
          <AccountBalanceOutlinedIcon fontSize='small' />
          Cuentas de banco
        </Button>
      )}
      {!isVerified && onVerifyUser && (
        <Button
          onClick={onVerifyUser}
          variant='contained'
          style={{
            ...baseStyle,
            backgroundColor: isDark ? 'rgba(16,185,129,0.1)' : '#b9ed94',
            color: isDark ? '#34d399' : '#166534'
          }}
        >
          <VerifiedUserOutlinedIcon fontSize='small' />
          Verificar
        </Button>
      )}
    </div>
  )
}
